import { useCallback, useMemo, useState } from "react";
import { INIT_LOADING_REQUEST, DEFAULT_MESSAGE } from "../constants";

const useLoadingRequest = () => {
	const [loadingRequest, setLoadingRequest] = useState({
		...INIT_LOADING_REQUEST,
	});
	const hide = useCallback(() => {
		setLoadingRequest(prev => ({
			...prev,
			hidden: true,
		}));
	}, []);
	const show = useCallback((message = DEFAULT_MESSAGE) => {
		setLoadingRequest({
			hidden: false,
			message: message,
		});
	}, []);
	return useMemo(
		() => ({
			value: loadingRequest,
			hide,
			show,
		}),
		[loadingRequest, hide, show]
	);
};

export default useLoadingRequest;
